import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

export const isEnterpriseProfileBarEnabled = (preview: boolean = false) => {
  if (preview) {
    return GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeProfileBar');
  } else {
    return GrowthDiscoveryEpicClient.get('enableEnterpriseHomeProfileBar');
  }
};
